import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=9276bdca&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=ts&"
export * from "./SuccessPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9276bdca",
  null
  
)

export default component.exports